var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6484 9.68862L15.3945 5.94247C15.8256 5.51144 15.8256 4.8126 15.3945 4.38157C14.9635 3.95054 14.2647 3.95054 13.8336 4.38157L10.0875 8.12772L6.34134 4.38157C5.91032 3.95054 5.21148 3.95054 4.78045 4.38157C4.34942 4.8126 4.34942 5.51144 4.78045 5.94247L8.5266 9.68862L4.78045 13.4348C4.34942 13.8658 4.34942 14.5646 4.78045 14.9957C5.21148 15.4267 5.91032 15.4267 6.34134 14.9957L10.0875 11.2495L13.8336 14.9957C14.2647 15.4267 14.9635 15.4267 15.3945 14.9957C15.8256 14.5646 15.8256 13.8658 15.3945 13.4348L11.6484 9.68862ZM10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20Z",
    fill: "#ADB5BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.9fed182d94ff21d25e67b38c5da6dc50.svg";
export { ForwardRef as ReactComponent };